export default "__VITE_ASSET__BH4T4N3h__"